import { getGlobal } from "@/functions/getGlobal";
import { event_helper } from "@/helpers/event_helper";
import classes from "./styles.module.scss";
import FormSection from "@/components/FormSection";
import Hero from "@/components/Hero";
import SeoHead from "@/components/SeoHead";

function convertDateFormat(dateString) {
  try {
    const dateObj = new Date(dateString);

    const day = dateObj.getDate();
    const month = dateObj.getMonth() + 1;
    const year = dateObj.getFullYear();

    const formattedDay = day.toString().padStart(2, "0");
      const monthNames = ["January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"];
    const formattedMonth = monthNames[month];

    const formattedDate = `${formattedDay} ${formattedMonth} ${year}`;

    return formattedDate;
  } catch (error) {
    console.error("Invalid date format. Please provide a valid ISO 8601 string.");
    return null;
  }
}

export default function EventPage({ title, canonical, event }) {

  const global = getGlobal();

  return (
    <>
      <SeoHead title={title} canonical={canonical} />
      <main className={classes.cont}>
        <Hero title={{path: "events.hero.title"}} background={{path:"events.hero.background"}}></Hero>
        <div className={classes.sub_cont}>
          <div className={classes.content}>
            <div className={classes.left_col}>
              <div className={classes.location}>
                <div className={`${classes.title}`}>LOCATION</div>
                <div className={classes.value}>{event.location}</div>
              </div>
              <div className={classes.date}>
                <div className={classes.title}>TIME</div>
                <h6 className={classes.value}>{convertDateFormat(event.date)}</h6>
              </div>
            </div>
            <div className={classes.right_col}>
              <span dangerouslySetInnerHTML={{ __html: event.content }} />
            </div>
          </div>
          <div className={classes.form}>
            <FormSection title="Register now" variant="dark" formId="612876c7-680b-4061-8072-fa818b56dfcf"></FormSection>
          </div>
        </div>
      </main>
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const event = event_helper.find(url_slug);

  return {
    props: {
      title: event.title,
      canonical: `/event/${url_slug}`,
      event
    },
  };
}

export async function getStaticPaths() {
  return { paths: event_helper.toPaths(), fallback: false };
}
